<template>
  <div>
    <b-card no-body>
      <div class="mx-2 mt-2">
        <!-- Table Top -->
        <resource-list-header
          :resource="RESOURCES.ROLES"
          :search-query="filters.search"
          @search="updateSearchQuery"
          @add="openModal"
          @export="exportData"
          :hideExport="true"
          :watch-link="roleVideoLink"
          :hide-watch="false"
        />
      </div>

      <!-- Table with Pagination -->
      <b-table
        ref="customerTable"
        :items="customers"
        :fields="tableColumns"
        responsive
        show-empty
        striped
        :busy="isLoading"
      >
        <!-- Loading slot with shimmer effect -->

        <template #table-busy class="p-0">
          <table-skeleton :columns="tableColumns" :rows="5" />
        </template>

        <!-- Column: Serial Number -->
        <template #cell(serial)="data">
          {{ data.item.serialNo }}
        </template>

        <!-- Column: ID -->
        <template #cell(id)="data"> {{ data.item.id }} </template>

        <!-- Column: Created At -->
        <!-- <template #cell(createdAt)="data">
          <timestamp-cell :timestamp="data.item.createdAt.date" :byUser="data.item.metaAddedBy" />
        </template> -->

        <!-- Column: Updated At -->
        <!-- <template #cell(updatedAt)="data">
          <timestamp-cell
            :timestamp="data.item.updatedAt ? data.item.updatedAt.date : null"
            :byUser="data.item.metaUpdatedBy"
          />
        </template> -->

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <action-cell
            :resource="RESOURCES.ROLES"
            :selected-resource-name="data.item.name"
            has-view-action
            has-edit-action
            has-delete-action
            @viewAction="viewCustomer(data.item)"
            @editAction="editRole(data.item)"
            @deleteAction="confirmDeleteCustomer(data.item)"
          />
        </template>
      </b-table>

      <!-- Pagination -->
      <div class="mx-2 mb-2 d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center">
          <label class="mb-0 mr-1">Show</label>
          <b-form-select
            v-model="filters.perPage"
            :options="pageOptions"
            size="sm"
            class="w-auto pagination-select"
            @change="handlePerPageChange"
          />
          <label class="mb-0 ml-1">entries</label>
        </div>
        <div class="pagination-info text-muted">
          {{ paginationInfo }}
        </div>
        <b-pagination
          v-model="filters.currentPage"
          :total-rows="pagination.totalRows"
          :per-page="filters.perPage"
          class="mb-0 pagination-modern"
          @change="handlePageChange"
        >
          <template #prev-text>
            <feather-icon icon="ChevronLeftIcon" size="18" />
          </template>
          <template #next-text>
            <feather-icon icon="ChevronRightIcon" size="18" />
          </template>
        </b-pagination>
      </div>
    </b-card>

    <DeleteConfirmationModal
      :show.sync="showModal"
      resource-name="Role"
      :item-name="selectedCustomer ? selectedCustomer.name : ''"
      :loading="deleteLoading"
      @deleteConfirmed="deleteCustomer(selectedCustomer)"
      @hideModal="handleModalHide"
      @onHide="handleModalHide"
    />

    <role-modal
      :is-editing="isEditing"
      :view-detail="viewDetail"
      :role="role"
      :business-i-d="businessID"
      :user-i-d="userID"
      @saved="handleRoleSaved"
      @close="handleRoleModalClose"
    />
  </div>
</template>

<script>
import DeleteConfirmationModal from '@/components/common/DeleteConfirmationModal.vue';
import ActionCell from '@/components/common/list/ActionCell.vue';
import TimestampCell from '@/components/common/list/TimestampCell.vue';
import { APIService } from '@/utils/api';
import { DATATABLE_SERIAL_COLUMNS, RESOURCES } from '@/utils/constants';
import StatisticCardHorizontal from '@core/components/statistics-cards/StatisticCardHorizontal.vue';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue';
import {
  BBadge,
  BBreadcrumb,
  BBreadcrumbItem,
  BButton,
  BCard,
  BCol,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BModal,
  BPagination,
  BRow,
  BTable,
  VBTooltip,
} from 'bootstrap-vue';
import { UserCheckIcon, UserMinusIcon, UsersIcon } from 'vue-feather-icons';
import vSelect from 'vue-select';
import RoleModal from './RoleModal.vue';

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BBreadcrumb,
    BBreadcrumbItem,
    BCard,
    BButton,
    BFormInput,
    BTable,
    BBadge,
    vSelect,
    StatisticCardHorizontal,
    UsersIcon,
    UserCheckIcon,
    UserMinusIcon,
    featherIcon: () => import('@core/components/feather-icon/FeatherIcon.vue'),
    BPagination,
    BFormSelect,
    AppBreadcrumb,
    TimestampCell,
    ActionCell,
    DeleteConfirmationModal,
    BModal,
    BFormGroup,
    BFormCheckbox,
    RoleModal,
  },
  data() {
    return {
      RESOURCES,
      isLoading: true,
      pageOptions: [
        { value: 20, text: '20' },
        { value: 40, text: '40' },
        { value: 60, text: '60' },
        { value: 100, text: '100' },
      ],

      pagination: {
        currentPage: 1,
        totalRows: 0,
      },

      filters: {
        currentPage: 1,
        perPage: 20,
        search: '',
      },

      // Table columns
      tableColumns: [
        ...DATATABLE_SERIAL_COLUMNS,
        { key: 'name', label: 'ROLE', thStyle: { minWidth: '150px' } },
        //{ key: 'createdAt', label: 'CREATED AT', thStyle: { minWidth: '150px' } },
        //{ key: 'updatedAt', label: 'UPDATED AT', thStyle: { minWidth: '150px' } },
        { key: 'actions', label: 'ACTIONS', thStyle: { width: '100px' } },
      ],

      customers: [],

      // Delete Modal
      showModal: false,
      deleteLoading: false,
      selectedCustomer: null,

      isExporting: false,

      filterChangeTimeout: null,

      all: {
        view: false,
        add: false,
        edit: false,
        delete: false,
      },
      myObj: [],
      roleObj: {
        id: 0,
        businessID: 0,
        name: '',
        forms: '',
      },
      request: false,
      isEditing: false,
      role: {},
      viewDetail: false,

      // Video link for Watch Now button
      roleVideoLink: 'https://cdn.cloudious.net/file-1756988643445-330481088.mp4',
    };
  },
  computed: {
    businessID() {
      // Try to get from user module first
      if (this.$store.state.user && this.$store.state.user.businessID) {
        return this.$store.state.user.businessID;
      }
      // Then try root state
      if (this.$store.state.businessID) {
        return this.$store.state.businessID;
      }
      // Finally try userData
      if (this.$store.state.userData && this.$store.state.userData.businessID) {
        return this.$store.state.userData.businessID;
      }
      return 1; // Default for testing
    },
    userID() {
      // Try to get from user module first
      if (this.$store.state.user && this.$store.state.user.userID) {
        return this.$store.state.user.userID;
      }
      // Then try root state
      if (this.$store.state.userID) {
        return this.$store.state.userID;
      }
      // Finally try userData
      if (this.$store.state.userData && this.$store.state.userData.userID) {
        return this.$store.state.userData.userID;
      }
      return 1; // Default for testing
    },
    paginationInfo() {
      const totalRows = this.pagination.totalRows;
      const start = totalRows === 0 ? 0 : (this.filters.currentPage - 1) * this.filters.perPage + 1;
      const end = Math.min(start + this.filters.perPage - 1, totalRows);
      return `${start} to ${end} of ${totalRows} entries`;
    },
  },
  watch: {
    filters: {
      handler(newVal) {
        // Ensure currentPage is defined
        if (!newVal.currentPage) {
          console.warn('currentPage was reset to null in watcher, fixing to 1');
          this.$nextTick(() => {
            this.filters.currentPage = 1;
          });
        }

        // Ensure perPage is maintained
        if (!newVal.perPage) {
          this.filters.perPage = 20;
        }

        // Use a debounced approach to avoid excessive API calls
        if (this.filterChangeTimeout) {
          clearTimeout(this.filterChangeTimeout);
        }

        this.filterChangeTimeout = setTimeout(() => {
          this.fetchCustomers();
        }, 300);
      },
      deep: true,
    },
    'filters.perPage': {
      handler(newVal) {
        if (!newVal) {
          console.warn('perPage was reset to null in watcher, fixing to 20');
          this.$nextTick(() => {
            this.filters.perPage = 20;
          });
        }
      },
      immediate: true,
    },
  },
  created() {
    this.filterChangeTimeout = null;
  },
  mounted() {
    this.fetchCustomers();
  },
  methods: {
    updateSearchQuery(query) {
      const currentPerPage = this.filters.perPage || 20; // Keep current perPage or default to 20
      this.filters.search = query;
      this.filters.currentPage = 1; // Reset to first page on search
      this.filters.perPage = currentPerPage; // Maintain the perPage value

      // Force immediate fetch to avoid undefined issues with pagination
      if (this.filterChangeTimeout) {
        clearTimeout(this.filterChangeTimeout);
      }
      this.fetchCustomers();
    },

    async fetchCustomers() {
      if (!this.businessID) {
        console.error('Business ID is required to fetch roles');
        return;
      }

      // Ensure perPage is always set
      if (!this.filters.perPage) {
        console.warn('perPage was reset to null, setting default value of 20');
        this.filters.perPage = 20;
      }

      // Ensure currentPage is always set
      if (!this.filters.currentPage) {
        console.warn('currentPage was reset to null, setting default value of 1');
        this.filters.currentPage = 1;
      }

      this.isLoading = true;

      // Create params with correct parameter names expected by the API
      const params = {
        pageNumber: this.filters.currentPage,
        pageSize: this.filters.perPage,
        search: this.filters.search,
      };

      try {
        // Use the regular pagination API
        const response = await APIService.getByPagination(
          RESOURCES.ROLES,
          this.businessID,
          params,
          this.userID
        );

        console.log('API Response:', response.data);

        // Extract the data based on API structure
        if (response?.data) {
          // Set the total rows count from the API response
          this.pagination.totalRows = response.data.totalCount || 0;

          // Check if we have results in the expected format
          if (response.data.results && Array.isArray(response.data.results)) {
            // Transform the results array
            this.customers = this.formatCustomers(response.data.results);

            console.log(
              `Loaded ${this.customers.length} roles for page ${this.filters.currentPage}, total: ${this.pagination.totalRows}`
            );
          } else {
            console.error('No results array found in API response', response.data);
            this.customers = [];
          }
        } else {
          console.error('Invalid API response format:', response);
          this.customers = [];
          this.pagination.totalRows = 0;
        }
      } catch (error) {
        console.error('Error fetching customers:', error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error',
            icon: 'AlertCircleIcon',
            variant: 'danger',
            text: 'Failed to fetch customers',
          },
        });
        this.customers = [];
        this.pagination.totalRows = 0;
      } finally {
        this.isLoading = false;
      }
    },

    formatCustomers(customers) {
      console.log('Formatting customers:', customers);
      return customers.map((customer, index) => {
        return {
          serialNo: index + 1,
          id: customer.id,
          name: customer.name || '',
          forms: customer.forms,
          createdAt: customer.addedOn
            ? {
                date: customer.addedOn,
                time: null,
              }
            : null,
          updatedAt: customer.updatedOn
            ? {
                date: customer.updatedOn,
                time: null,
              }
            : null,
          metaAddedBy: customer.metaAddedBy,
          metaUpdatedBy: customer.metaUpdatedBy,
        };
      });
    },

    async editRole(role) {
      try {
        this.isEditing = true;
        this.viewDetail = false;

        // Fetch the latest role data before editing
        const response = await APIService.getById(
          RESOURCES.ROLES,
          role.id,
          this.businessID,
          this.userID
        );

        if (response?.data?.status === 'success') {
          this.role = response.data.data;
          this.$bvModal.show('modal-roles');
        } else {
          throw new Error('Failed to load role data');
        }
      } catch (error) {
        console.error('Error loading role for edit:', error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error',
            icon: 'AlertCircleIcon',
            variant: 'danger',
            text: 'Failed to load role data for editing',
          },
        });
      }
    },

    async viewCustomer(customer) {
      try {
        this.isEditing = true;
        this.viewDetail = true;
        // Fetch the latest role data before viewing
        const response = await APIService.getById(
          RESOURCES.ROLES,
          customer.id,
          this.businessID,
          this.userID
        );

        if (response?.data?.status === 'success') {
          this.role = response.data.data;
          this.$bvModal.show('modal-roles');
        } else {
          throw new Error('Failed to load role data');
        }
      } catch (error) {
        console.error('Error loading role for view:', error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error',
            icon: 'AlertCircleIcon',
            variant: 'danger',
            text: 'Failed to load role data for viewing',
          },
        });
      }
    },

    confirmDeleteCustomer(customer) {
      this.selectedCustomer = customer;
      this.showModal = true;
    },

    async deleteCustomer(customer) {
      // Set loading state to true
      this.deleteLoading = true;
      const uid = this.userID;

      try {
        await APIService.delete(RESOURCES.ROLES, customer.id, this.businessID, uid);

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Roles Deleted',
            icon: 'TrashIcon',
            variant: 'success',
            text: 'Roles has been deleted successfully',
          },
        });

        this.fetchCustomers();
      } catch (error) {
        console.error('Error deleting customer:', error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error',
            icon: 'AlertCircleIcon',
            variant: 'danger',
            text: 'Failed to delete customer',
          },
        });
      } finally {
        // Reset loading state and selected warehouse
        this.deleteLoading = false;
        this.selectedCustomer = null;
        this.showModal = false;
      }
    },

    async exportData() {
      if (!this.businessID) {
        console.error('Business ID is required for export operation');
        return;
      }

      try {
        this.isExporting = true;

        // Build params object with active filters
        const params = {
          search: this.filters.search || '',
        };

        // Add status filter if selected
        if (this.selectedStatus !== 'All') {
          params.active = this.selectedStatus === 'Active';
        }

        const response = await APIService.export(
          RESOURCES.CUSTOMERS,
          this.businessID,
          this.userID,
          params
        );

        if (response.data?.status === 'success') {
          // Get the file path from the response
          const filePath = response.data.data.filePath;

          // Construct the full download URL
          const baseURL = process.env.VUE_APP_BASE_URL; // Replace with your actual base URL
          const downloadURL = `${baseURL}${filePath}`;

          // Create a link element and trigger download
          const link = document.createElement('a');
          link.href = downloadURL;
          link.download = filePath.split('/').pop(); // Get the filename from the path
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Export Successful',
              icon: 'CheckIcon',
              variant: 'success',
              text: response.data.message || 'Customers data exported successfully',
            },
          });
        } else {
          throw new Error('Invalid response format from server');
        }
      } catch (error) {
        console.error('Error exporting customers:', error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Export Failed',
            icon: 'AlertCircleIcon',
            variant: 'danger',
            text:
              error.response?.data?.message || error.message || 'Failed to export customers data',
          },
        });
      } finally {
        this.isExporting = false;
      }
    },

    handleModalHide() {
      // Only reset if not in loading state
      if (!this.deleteLoading) {
        this.selectedCustomer = null;
        this.showModal = false;
      }
    },

    handlePageChange(page) {
      console.log(`Moving to page ${page}`);
      // Update the current page in filters
      this.filters.currentPage = page;
      // Force fetch data for this page
      this.fetchCustomers();
    },

    handlePerPageChange(value) {
      console.log(`Changing items per page to ${value}`);
      // Update perPage value and reset to first page
      this.filters.perPage = parseInt(value, 10);
      this.filters.currentPage = 1;
      // Force refresh data with new perPage value
      this.fetchCustomers();
    },

    handleFilterChange(newFilters) {
      // Reset to page 1 when filters change
      this.filters.currentPage = 1;

      // Ensure perPage value is preserved when filters change
      if (!this.filters.perPage) {
        console.warn('perPage was reset during filter change, restoring to 20');
        this.filters.perPage = 20;
      }
    },

    async openModal() {
      try {
        this.all = {
          view: false,
          add: false,
          edit: false,
          delete: false,
        };
        this.request = true;
        this.isEditing = false;
        this.role = {};
        this.myObj = [];
        const response = await APIService.loadData(RESOURCES.ROLES, this.businessID, this.userID);
        if (response?.data?.status === 'success') {
          this.myObj = response?.data?.data || [];
        } else {
          this.myObj = [];
        }
        if (this.myObj.length == 0) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Error',
              icon: 'AlertCircleIcon',
              variant: 'danger',
              text: 'Failed to Load Forms',
            },
          });
        } else {
          this.roleObj = {
            id: 0,
            name: '',
            forms: '',
            businessID: this.businessID,
          };
          this.$bvModal.show('modal-roles');
        }
      } catch (error) {
        console.error('Error loading forms:', error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error',
            icon: 'AlertCircleIcon',
            variant: 'danger',
            text: 'Failed to load forms',
          },
        });
      } finally {
        this.request = false;
      }
    },

    ToggleAll(name) {
      this.myObj.forEach((groups) => {
        groups.children.forEach((forms) => {
          if (name == 'view') forms.view = this.all.view;
          else if (name == 'add') forms.add = this.all.add;
          else if (name == 'edit') forms.edit = this.all.edit;
          else if (name == 'delete') forms.delete = this.all.delete;
        });
      });
    },

    CheckRoleName() {
      var elem = this.$refs['name'];
      if (this.roleObj.name == '') {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },

    async save() {
      this.CheckRoleName();
      if (this.CheckRoleName() == false) {
        return this.$bvToast.toast('Please enter the role.', {
          title: 'Error!',
          variant: 'danger',
          toaster: 'b-toaster-top-center',
        });
      } else {
        try {
          this.request = true;
          let newTabs = [];

          // Create a deep copy of the data structure
          let fData = JSON.parse(JSON.stringify(this.myObj));

          fData.forEach((item) => {
            let itemChildren = [];

            item.children.forEach((el) => {
              let elCopy = { ...el };
              if (elCopy.route != null) {
                elCopy.route = elCopy.route.replace('\n', '');
              }
              if (elCopy.view || elCopy.add || elCopy.edit || elCopy.delete || elCopy.permission) {
                itemChildren.push(elCopy);
              }
            });

            let newItem = {
              ...item,
              children: itemChildren,
            };

            if (itemChildren.length > 0) {
              newTabs.push(newItem);
            }
          });

          if (newTabs.length == 0) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Error',
                icon: 'AlertCircleIcon',
                variant: 'danger',
                text: 'No permissions selected',
              },
            });
            return;
          }
          this.roleObj.forms = JSON.stringify(newTabs);

          await APIService.save(RESOURCES.ROLES, this.roleObj, this.businessID, this.userID);

          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Success',
              icon: 'CheckIcon',
              variant: 'success',
              text: this.roleObj.id ? 'Role updated successfully' : 'Role saved successfully',
            },
          });

          this.request = false;
          this.fetchCustomers();
          this.$bvModal.hide('modal-roles');
        } catch (error) {
          console.error('Error saving role:', error);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Error',
              icon: 'AlertCircleIcon',
              variant: 'danger',
              text: 'Failed to save role',
            },
          });
        } finally {
          this.request = false;
        }
      }
    },

    async addRole() {
      this.isEditing = false;
      this.role = {};
      this.$bvModal.show('modal-roles');
    },

    async handleRoleSaved() {
      // Reset the editing state
      this.isEditing = false;
      this.viewDetail = false;
      this.role = {};

      // Refresh the roles list
      await this.fetchCustomers();
    },

    handleRoleModalClose() {
      // Reset the state when modal is closed
      this.isEditing = false;
      this.viewDetail = false;
      this.role = {};
    },

    async loadData() {
      try {
        this.isBusy = true;
        const response = await APIService.getWithAllCount(RESOURCES.ROLES, this.businessID);
        if (response?.data?.status === 'success') {
          this.data = response.data.results;
          this.totalRows = response.data.totalCount;
        } else {
          this.data = [];
          this.totalRows = 0;
        }
      } catch (error) {
        console.error('Error loading roles:', error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error',
            icon: 'AlertCircleIcon',
            variant: 'danger',
            text: 'Failed to load roles',
          },
        });
        this.data = [];
        this.totalRows = 0;
      } finally {
        this.isBusy = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.pagination-select {
  min-width: 80px;
  background-color: #f8f8f8;
  border-color: #ddd;
}

.pagination-modern {
  .page-item {
    margin: 0 0.2rem;

    .page-link {
      border-radius: 0.358rem;
      border: none;
      min-width: 36px;
      height: 36px;
      line-height: 36px;
      padding: 0;
      text-align: center;
      font-weight: 500;
      background-color: #f8f8f8;
      color: #6e6b7b;

      &:hover {
        background-color: #7367f0;
        color: #fff;
      }
    }

    &.active .page-link {
      background-color: #7367f0;
      color: #fff;
    }
  }
}

.scrollContent {
  max-height: 50vh;
  overflow-y: scroll;
}
</style>
